"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThreadMode = void 0;
exports.defineService = defineService;
exports.implementService = implementService;
var ThreadMode;
(function (ThreadMode) {
    ThreadMode[ThreadMode["MAIN"] = 0] = "MAIN";
    ThreadMode[ThreadMode["REMOTE"] = 1] = "REMOTE";
})(ThreadMode || (exports.ThreadMode = ThreadMode = {}));
function defineService(id) {
    return id;
}
function implementService(_, factory) {
    return factory;
}
implementService.withConfig = function () {
    return function (_, factory) {
        return factory;
    };
};
